const FormStaticImgConfig = {
  componentType: 'FORM_STATIC_IMG',
  widgetConfig: {
    icon: 'x-lib-static-img',
    text: '静态图片',
    description: '用于展示固定图片，点击图片可全屏预览'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12,
    height: 1,
    // staticDefaultValue: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1594208392236&di=a14833032cab3aa55be2d1bd5791949d&imgtype=0&src=http%3A%2F%2Ft9.baidu.com%2Fit%2Fu%3D3363001160%2C1163944807%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D830',
    render: {
      ide: 'FormStaticImg',
      edit: 'FormStaticImg',
      read: 'FormStaticImg'
    }
  },
  editorConfig: ['INFO', 'STATIC_IMG_DEFAULT', 'IMG_HEIGHT_LIMIT', 'HIDDEN']
}

export default FormStaticImgConfig
